<template id="contact">
  <div>
    <ou-button @click='multilineDialogVisible=true'>{{ contact.EmailAddresses[0].Address }}</ou-button>
    <ou-dialog
          type='close'
          v-bind:title='contact.EmailAddresses[0].Address'
          v-model='multilineDialogVisible'>
        <ou-text-field v-model='GivenName' label='Name' />
        <ou-text-field v-model='Surname' label='Surname' />
        <ou-text-field v-model='Email' label='Email' />
        <ou-text-field v-model='Phone' label='Phone' />
        <ou-text-field v-model='CompanyName' label='Company' />
        <ou-button type='small' v-on:click="updateContact">Save</ou-button>
      </ou-dialog>
  </div>
</template>
<script>
export default {
  name: 'contact',
  props: ['contact'],
  data () {
    return {
      multilineDialogVisible: false,
    }
  },
  mounted () {
    this.GivenName = this.contact.GivenName
    this.Surname = this.contact.Surname
    this.Email = this.contact.EmailAddresses[0].Address
    this.Phone = this.contact.BusinessPhones[0]
    this.CompanyName = this.contact.CompanyName
  },
  methods: {
    updateContact () {
      this.contact.GivenName = this.GivenName
      this.contact.Surname = this.Surname
      this.contact.EmailAddresses[0].Address = this.Email
      this.contact.BusinessPhones[0] = this.Phone
      this.contact.CompanyName = this.CompanyName
      this.$emit('updateContact', this.contact)
      this.multilineDialogVisible = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue